import { render, staticRenderFns } from "./CustomerIcon.vue?vue&type=template&id=2d53562d"
import script from "./CustomerIcon.vue?vue&type=script&lang=js"
export * from "./CustomerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports